import { ReactComponent as ArrowRightIcon } from 'assets/icons/arrow-right.svg';

import type ICustomPagination from './interfaces/ICustomPagination';

import styles from './scss/CustomPagination.module.scss';

function CustomPagination({
  currentPage,
  totalPages,
  onPageChange,
  className,
}: ICustomPagination) {
  if (totalPages <= 1) return null;

  const generatePageNumbers = () => {
    const pages: (number | string)[] = [];
    const range = 2;
    pages.push(1);
    const rangeStart = Math.max(2, currentPage - range);
    const rangeEnd = Math.min(totalPages - 1, currentPage + range);
    if (currentPage - range > 2) {
      pages.push('...');
    }
    Array.from({ length: rangeEnd - rangeStart + 1 }, (_, index) => rangeStart + index)
      .forEach((pageNum) => pages.push(pageNum));
    if (currentPage + range < totalPages - 1) {
      pages.push('...');
    }
    if (totalPages > 1 && !pages.includes(totalPages)) {
      pages.push(totalPages);
    }
    return Array.from(new Set(pages));
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const pageNumbers = generatePageNumbers();

  return (
    <div className={`${styles.pagination} ${className || ''}`}>
      <button
        type="button"
        className={`${styles.pageButton} ${styles.arrow}`}
        onClick={handlePrevious}
        disabled={currentPage === 1}
        aria-label="Previous page"
      >
        <ArrowRightIcon style={{ transform: 'rotate(180deg)' }} />
      </button>

      {pageNumbers.map((page) => {
        if (page === '...') {
          return (
            <div key="ellipsis-end" className={styles.ellipsis}>
              ...
            </div>
          );
        }

        return (
          <button
            key={page}
            type="button"
            className={`${styles.pageButton} ${
              currentPage === page ? styles.active : ''
            }`}
            onClick={() => onPageChange(page as number)}
            aria-label={`Go to page ${page}`}
            aria-current={currentPage === page ? 'page' : undefined}
          >
            {page}
          </button>
        );
      })}

      <button
        type="button"
        className={`${styles.pageButton} ${styles.arrow}`}
        onClick={handleNext}
        disabled={currentPage === totalPages}
        aria-label="Next page"
      >
        <ArrowRightIcon />
      </button>
    </div>
  );
}

export default CustomPagination;
